import HoursControl from './component'

export default HoursControl
